import React, { useState } from 'react';
import { ShieldCheckIcon, Share2Icon } from 'lucide-react';
import { ShareCardFrame } from '../../components/engagement/ShareCardFrame';
import { ShareSheet } from '../../components/engagement/ShareSheet';
import { PageHeader } from '../../components/PageHeader';
import { SettingsGroup, SettingsToggleRow } from '../../components/SettingsList';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { useLocale } from '../../contexts/LocaleContext';
import { useProgress } from '../../contexts/ProgressContext';
import { bandKey } from '../../utils/progress';

/** MOB/Stats/LifeScoreShare — opt-in card for Stories / WhatsApp. */
export function LifeScoreShare() {
  const {
    t
  } = useLocale();
  const progress = useProgress();
  const [includeStreak, setIncludeStreak] = useState(true);
  const [includeHabits, setIncludeHabits] = useState(false);
  const [sharing, setSharing] = useState(false);
  return <div className="px-2 pb-2" data-id="element-2795" data-mp="1c40787ppkkx0">
      <PageHeader title={t('eng.share.title')} subtitle={t('eng.share.subtitle')} showBack data-id="element-2796" data-mp="h2n3s4e4lt9a" />

      <ShareCardFrame label={t('eng.share.title')} data-id="element-2797" data-mp="c2r0y8h607vb">
        <p className="bee-overline text-[8.5px] font-bold text-ondark" data-id="element-2798" data-mp="c42549eivhmy">{t('eng.share.today')}</p>
        <p className="bee-num mt-1 text-[72px] font-bold leading-none text-sand" data-id="element-2799" data-mp="72crqn3turvp">
          {progress.todayScore}
          <span className="text-[20px] text-ondark" data-id="element-2800" data-mp="27gvfark5ics">/100</span>
        </p>
        <div className="mt-2 h-[5px] overflow-hidden rounded-pill bg-sand/15" aria-hidden="true" data-id="element-2801" data-mp="3uaghw5121ljr">
          <div className="h-full rounded-pill bg-gold" style={{
          width: `${progress.todayScore}%`
        }} data-id="element-2802" data-mp="3pglv2sq5kqgg" />
        </div>
        <p className="mt-2 text-[12px] font-medium text-gold" data-id="element-2803" data-mp="3kgzmiwl9rydz">{t(bandKey(progress.band))}</p>
        {(includeStreak || includeHabits) && <ul className="mt-3 space-y-1 border-t border-sand/15 pt-2 text-[12px]" data-id="element-2804" data-mp="3alfpu7yvsvo6">
            {includeStreak && <li className="bee-num" data-id="element-2805" data-mp="36kdq7q11yhlo">{t('eng.share.streak', {
            n: progress.streak
          })}</li>}
            {includeHabits && <li className="bee-num" data-id="element-2806" data-mp="2w0bpya5swrmi">{t('eng.share.habits', {
            n: progress.completedCount
          })}</li>}
          </ul>}
      </ShareCardFrame>

      <div className="mt-3" data-id="element-2807" data-mp="2mykkn6f6amt6">
        <SettingsGroup data-id="element-2808" data-mp="2mzdifhw5m1z6">
          <SettingsToggleRow label={t('eng.share.includeStreak')} checked={includeStreak} onChange={setIncludeStreak} data-id="element-2809" data-mp="2mzvjqsxob6dy" />
          <SettingsToggleRow label={t('eng.share.includeHabits')} checked={includeHabits} onChange={setIncludeHabits} data-id="element-2810" data-mp="3fmq4lqyek7ry" />
        </SettingsGroup>
      </div>

      <Card className="mt-2 p-2" data-id="element-2811" data-mp="35vvf8dpv0s2a">
        <p className="flex items-start gap-1 text-[12px] leading-snug text-deep" data-id="element-2812" data-mp="3avhu0rlc6gd7">
          <ShieldCheckIcon size={15} className="mt-[1px] shrink-0 text-soft" aria-hidden="true" data-id="element-2813" data-mp="3atdknu4o4p5j" />
          {t('eng.share.privacy')}
        </p>
      </Card>

      <Button variant="primary" size="lg" fullWidth className="mt-3" onClick={() => setSharing(true)} data-id="element-2814" data-mp="77g58qlwdgnv">
        <Share2Icon size={16} aria-hidden="true" data-id="element-2815" data-mp="gjvrxw0966f1" />
        {t('eng.share.button')}
      </Button>

      <ShareSheet open={sharing} onClose={() => setSharing(false)} data-id="element-2816" data-mp="citpz7eybg9d" />
    </div>;
}